<template>
  <kendo-window
    ref="window"
    :width="'700px;'"
    :title="title"
    :visible="visible"
    style="display:none"
    @close="onClose"
    :modal="true"
  >
    <v-form ref="editForm" @submit.prevent="save">
      <div class="row">
        <div class="col-md-6 col-xs-12">
          <v-text-field
            label="Label"
            v-model="label"
            required
            :rules="[v => !!v || 'Label is required!']"
          >
          </v-text-field>
        </div>
        <div class="col-md-6 col-xs-12">
          <v-select
            label="Language"
            :items="languages"
            item-text="language"
            item-value="languageId"
            v-model="languageId"
            width="50"
          >
          </v-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-xs-12">
          <v-text-field
            label="Description"
            v-model="description"
            required
            :rules="[v => !!v || 'Description is required!']"
          >
          </v-text-field>
        </div>
        <div class="col-md-6 col-xs-12">
          <v-text-field
            label="Note"
            v-model="note"
            required
            :rules="[v => !!v || 'Note is required!']"
          >
          </v-text-field>
        </div>
      </div>
      <div class="row"><v-textarea label="Disclaimer" v-model="disclaimer"> </v-textarea></div>
      <hr class="v-divider theme--light" />
      <div class="panel-footer">
        <div class="row">
          <div class="spacer"></div>
          <v-btn color="blue primary" @click="save">Save</v-btn>
        </div>
      </div>
    </v-form>
  </kendo-window>
</template>
<script>
import axios from 'axios'
import notification from '@/helpers/notification'
import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
  async mounted() {
    const {data: languages} = await axios.get('/api/report/dashboardPage/getLanguages')
    const dashboardId = this.dashboardId

    this.languages = languages

    if (dashboardId != 0) {
      const {data} = await axios.get('/api/report/dashboardPage/getDashboard', {
        params: {dashboardId},
      })

      this.label = data.label
      this.description = data.description
      this.languageId = data.languageId
      this.note = data.note
      this.disclaimer = data.disclaimer
    }

    let window = this.$refs.window.kendoWidget()
    window.center().open()
  },
  props: {
    dashboardId: {
      type: Number,
    },
  },
  data() {
    return {
      languages: [],
      visible: true,
      title: 'Dashboard',
      label: '',
      description: '',
      languageId: -1,
      note: '',
      disclaimer: '',
    }
  },
  methods: {
    cancel() {
      this.$refs.window.kendoWidget().close()
    },
    async save() {
      if (this.$refs.editForm.validate()) {
        const item = {
          label: this.label,
          dashboardId: this.dashboardId,
          clientId: this.clientId,
          languageId: this.languageId,
          description: this.description,
          note: this.note,
          disclaimer: this.disclaimer,
        }
        if (this.dashboardId == 0) {
          const create = await axios.post('/api/report/dashboardPage/createDashboard', item)
          if (create.error) {
            notification(create.error, 'error')
          } else {
            this.label = create.data.label
            this.description = create.data.description
            this.languageId = create.data.languageId
            this.note = create.data.note
            this.disclaimer = create.data.disclaimer

            this.$emit('save', create.data)
          }
        } else {
          const edit = await axios.put('/api/report/dashboardPage/updateDashboard', item)
          if (edit.error) {
            notification(edit.error, 'error')
          } else {
            this.label = edit.data.label
            this.description = edit.data.description
            this.languageId = edit.data.languageId
            this.note = edit.data.note
            this.disclaimer = edit.data.disclaimer

            this.$emit('save', edit.data)
          }
        }
      }
    },
    onClose() {
      this.$emit('close')
    },
  },
}
</script>
